import HeartSolidIcon from '@eduzz/houston-icons/HeartSolid';
import { Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import React from 'react';

import { useStyles } from './styles';

type SolidaritySquadAlertProps = {
  onBtnClick: () => void;
};

function SolidaritySquadAlert({ onBtnClick }: SolidaritySquadAlertProps) {
  const classes = useStyles();

  return (
    <Alert
      severity='info'
      action={
        <Button variant='outlined' color='secondary' startIcon={<HeartSolidIcon />} fullWidth onClick={onBtnClick}>
          Quero colaborar
        </Button>
      }
      classes={{
        root: classes.root,
        action: classes.action,
      }}
    >
      Colabore para transformar vidas e a comunidade por meio da educação, qualificação profissional e empreendedorismo.{' '}
      <a href='https://www.projetoelevar.org.br/' target='_blank' rel='noopener noreferrer'>
        Clique aqui para saber mais.
      </a>
    </Alert>
  );
}

export { SolidaritySquadAlert };
